var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.$style.block,style:(`gridTemplateColumns: repeat(auto-fill, minmax(${_vm.minTileWidth}, 1fr);`)},_vm._l((_vm.playlists),function(playlist,index){return _c('PlaylistsGridTile',{key:playlist.id,class:_vm.$style.tile,attrs:{"playlist":playlist,"index":index,"type":_vm.type}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }